import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { OrderType, PaginationType } from "../../types";
import { Pagination } from "../../ui/pagination";
import { useAppState, ContextState } from "../../context";

import OrderRow from "./orders/order-row";
export const OrdersPage = () => {

    const [pagination] = useState<PaginationType | undefined>();
    const [orders] = useAppState<OrderType[]>("orders", []);
    const [searchParams, setSearchParams] = useSearchParams();
    const { refetchInitiate } = useContext(ContextState);

    useEffect(() => {
        if (searchParams.get('speedUp') !== 'success') {
            return;
        }
        refetchInitiate().finally(() => {
            searchParams.delete('speedUp');
            setSearchParams(searchParams, { replace: true });
        });
    }, [searchParams, setSearchParams, refetchInitiate]);
    
    const [expanded, setExpanded] = useState<Record<number, boolean>>(orders.reduce((acc, order) => {
        acc[order.id] = false;
        return acc;
    }, {} as Record<number, boolean>));


    return (
        <>
            <h1 className="section__title">
                Your Orders List
            </h1>

            {!orders.length && <div className="orderlist">
                <div className="orderlist__item">
                    <div className="orderlist__item-inner">
                        <div className="orderlist__item-title">No orders found</div>
                    </div>
                </div>
            </div>}
            {orders.length > 0 && <div className="orderlist">
                {orders.map((order) => (
                    <OrderRow
                        key={order.id}
                        order={order}
                        expanded={expanded[order.id]}
                        setExpanded={(expanded) => setExpanded(prev => ({ ...prev, [order.id]: expanded }))}
                    />
                ))}
            </div>}
            {pagination && <Pagination {...pagination} />}
        </>
    );
};

export default OrdersPage; 